import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertTemplatePagesMutation, InsertTemplatePagesMutationVariables } from '@/graphql/generated/graphql';
import { InsertTemplatePagesDocument } from '@/graphql/generated/graphql';
export type TemplatePagesInsertInput = {
  OrganizationIds?: string[]
  Slug: string
  Locale?: string
  Keywords?: string[]
  Title: string
  Description?: string
  HtmlBody?: string
  OgTitle?: string | null
  OgDescription?: string | null
  OgImage?: string | null
  Published?: boolean
  Blocks?: string
}

export type TemplatePagesInsertResponse = {
  data: {
    insertTemplatePages: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertTemplatePage = () => {
  const mutation = useMutation({
    mutationKey: ['insert-template-page'],
    mutationFn: (variables: TemplatePagesInsertInput) => {
      return graphqlClient.request<InsertTemplatePagesMutation>(InsertTemplatePagesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertTemplatePage: mutation.mutate,
    insertTemplatePageAsync: mutation.mutateAsync,
  }
}

export const INSERT_TEMPLATE_PAGE_MUTATION = InsertTemplatePagesDocument;
